import script from "./RemindersList.vue?vue&type=script&setup=true&lang=js"
export * from "./RemindersList.vue?vue&type=script&setup=true&lang=js"

import "./RemindersList.vue?vue&type=style&index=0&id=aa835aea&lang=css"

const __exports__ = script;

export default __exports__